<template>
  <el-card>
    <section>
      <!--工具条-->
      <el-col :span="24" class="form-line">
        <el-form size="small" :inline="true" :model="filters">
          <el-form-item label="角色名称">
            <el-input v-model="filters.roleName" placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <div style="float: right">
            <el-form-item>
              <el-button-group>
                <el-button type="primary" icon="el-icon-search" @click="getRoleList()">查询</el-button>
                <el-button icon="el-icon-refresh-right" @click="resetFilter()">重置</el-button>
              </el-button-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleAdd">新增</el-button>
            </el-form-item>
          </div>
        </el-form>
      </el-col>
      <!--列表-->
      <el-table border size="medium" :data="roleList" highlight-current-row v-loading="listLoading" @selection-change="selsChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column type="index" min-width="60">
        </el-table-column>
        <el-table-column prop="roleName" label="角色名称" min-width="120">
        </el-table-column>
        <el-table-column prop="description" label="角色备注" min-width="240">
        </el-table-column>
        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleRight(scope.$index, scope.row)">权限分配</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--工具条-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="padding: 15px 5px">
      </el-pagination>

      <!--新增界面-->
      <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form size="small" :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-form-item label="角色名称" prop="roleName">
            <el-input v-model="addForm.roleName" maxlength="50" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="角色备注">
            <el-input type="textarea" maxlength="100" v-model="addForm.description"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="addFormVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--权限分配弹窗-->
      <el-dialog title="权限分配" :visible.sync="rightVisible" :close-on-click-modal="false">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="custom-tree-container">
              <div class="block">
                <el-tree
                  :data="menuData"
                  node-key="id"
                  show-checkbox
                  default-expand-all
                  :expand-on-click-node="false"
                  :props="treeProps"
                  ref="tree">
                  <template #default="{ node, data }">
                  <span class="custom-tree-node">
                    <span>{{ node.label }}</span>
                  </span>
                  </template>
                </el-tree>
              </div>
            </div>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="rightVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click.native="changeRight" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
    </section>
  </el-card>
</template>

<script>

import { doPost, download } from '../../api/api'

export default {
  data () {
    return {
      filters: {
        roleName: ''
      },
      roleList: [],
      total: 0,
      listLoading: false,
      sels: [], // 列表选中列

      addFormVisible: false, // 新增界面是否显示
      addLoading: false,
      addFormRules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ]
      },
      // 新增界面数据
      addForm: {
        systemFlag: 'service-mdinfo',
        roleName: '',
        description: ''
      },
      messageTitle: '',
      messageSuc: '',
      value: '',
      value1: new Date(2016, 9, 10, 18, 40),
      value2: '',
      value3: '',
      rightId: '',
      rightVisible: false,
      treeProps: { label: 'menuName', children: 'sonList' },
      menuData: []
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.pageSize = val
      this.getRoleList()
    },
    handleCurrentChange (val) {
      this.filters.pageNum = val
      this.getRoleList()
    },
    changeRight () {
      var right = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())
      var para = {
        id: this.rightId,
        menuListStr: JSON.stringify(right)
      }
      doPost('/sysRole/updateAllSysRoleMenu', para).then((res) => {
        //        console.log(res)
        this.$message({
          message: '权限更新成功',
          type: 'success'
        })
        this.rightVisible = false
      })
    },
    // 显示编辑界面
    handleRight: function (index, row) {
      this.rightId = row.id
      // 清空上次选择得权限
      var para = { roleId: row.id }
      doPost('/sysRole/getSysRoleMenuList', para).then((res) => {
        this.rightVisible = true
        //        console.log(res)
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys([])
          var that = this
          if (res.result) {
            for (var i = 0; i < res.result.length; i++) {
              var node = that.$refs.tree.getNode(res.result[i].menuId)
              //                console.log(node)
              if (node.isLeaf) {
                // 叶子节点才选中
                that.$refs.tree.setChecked(node, true)
              }
            }
          }
        })
      })
    },
    resetFilter () {
      Object.assign(this.$data.filters, this.$options.data().filters)
    },
    // 获取用户列表
    getRoleList () {
      this.loading = true
      doPost('/sysRole/getPageList', this.filters).then((res) => {
        //        console.log(res.result)
        this.roleList = res.result.list
        this.total = res.result.total
        this.loading = false
      })
    },
    downloadUser () {
      // axios下载数据
      download('/user/downloadUser', this.filters, '用户数据.xls')
    },
    // 删除
    handleDel: function (index, row) {
      //      this.$confirm('确认删除该记录吗?', '提示', {
      //        type: 'warning'
      //      }).then(() => {
      //        this.listLoading = true
      //        //        let para = { id: row.id }
      //        //        removeUser(para).then((res) => {
      //        //          this.listLoading = false
      //        //          this.$message({
      //        //            message: '删除成功',
      //        //            type: 'success'
      //        //          })
      //        //          this.getUsers()
      //        //        })
      //      }).catch(() => {
      //
      //      })
    },
    // 显示新增界面
    handleAdd: function () {
      this.addFormVisible = true
      this.addForm = {
        systemFlag: 'service-mdinfo',
        roleName: '',
        description: ''
      }
      this.messageTitle = '新增'
      this.messageSuc = '新增成功'
    },
    // 显示编辑界面
    handleEdit: function (index, row) {
      this.addFormVisible = true
      var para = { id: row.id }
      doPost('/sysRole/getById', para).then((res) => {
        this.addForm = res.result
      })
      this.messageTitle = '修改'
      this.messageSuc = '修改成功'
    },
    // 新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.addLoading = true
            doPost('/sysRole/saveOrUpdate', this.addForm).then(res => {
              if (res.code === 0) {
                this.addFormVisible = false
                this.addLoading = false
                // 修改成功  提示信息
                this.$message({
                  message: this.messageSuc,
                  type: 'success'
                })
                this.getRoleList()
              }
            })
          })
        }
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    // 获取菜单树形结构
    getMenuList () {
      this.listLoading = true
      doPost('/sysMenu/getSysMenuTree', {}).then((res) => {
        //        console.log(res.result)
        this.menuData = res.result
        this.listLoading = false
      })
    },
    // 批量删除
    batchRemove: function () {
      //      var ids = this.sels.map(item => item.id).toString()
      //      this.$confirm('确认删除选中记录吗？', '提示', {
      //        type: 'warning'
      //      }).then(() => {
      //        this.listLoading = true
      //        //        let para = { ids: ids }
      //        //        batchRemoveUser(para).then((res) => {
      //        //          this.listLoading = false
      //        //          this.$message({
      //        //            message: '删除成功',
      //        //            type: 'success'
      //        //          })
      //        //          this.getUsers()
      //        //        })
      //      }).catch(() => {
      //
      //      })
    }
  },
  mounted () {
    this.getRoleList()
    this.getMenuList()
  }
}

</script>

<style scoped>

</style>
